<template>
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{ show: isShowLeftSidebar }"
      @click="isShowLeftSidebar = false"
    />

    <filters
      :options="donVis"
      :default-option.sync="donViFilter"
      @fetch-data="fetchData"
    />

    <data-table
      :data-table="dataTable"
      :search-ref.sync="searchTerm"
      :is-loaded="dataTableIsLoaded"
      @show-edit="showLeftSlidebar"
      @remove-item="removeItem"
      :total-rows="totalRows"
      :data-meta="dataMeta"
      @update-pagination="pagination"
      @update-perpage="perpage"
      @update-searchquery="searchquery"
    />
  </div>
</template>

<script>
/* eslint-disable */
import LayoutData from "@/layouts/LayoutData";
import {} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

import DataTable from "./components/DataTable.vue";

import { ref, computed, watch } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";

import Filters from "./components/Filters.vue";

import useSetup from "./useSetup";

export default {
  directives: {
    Ripple,
  },
  components: {
    Filters,
    DataTable,
  },
  data() {
    return {
      isWait: false,
    };
  },
  watch: {},
  methods: {},
  created() {},
  setup(props, { emit }) {
    const toast = useToast();
    const { route, router } = useRouter();
    const headerData = ref(LayoutData.header.data);
    const appInfo = ref();
    headerData.value.title = "Cán bộ công chức";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;

    const totalRows = ref(0);
    const dataMeta = ref({});

    const {
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,

      getDataList,
      getDonVi,
    } = useSetup();
    const donViFilter = ref(null);
    const donVis = ref([]);
    // console.log(donVis.value);

    getDonVi({}, (data) => {
      donVis.value = data;
      if (data.length > 0) {
        donViFilter.value = data[0].id;
        // fetchData(data[0].id);
      }
    });
    // if (donVis.value.length > 0) {
    //   donViFilter.value = donVis[0].id;
    // }
    // console.log("roles", roles.value);

    const dataTable = ref([]);
    const isShowLeftSidebar = ref(false);
    const dataTableIsLoaded = ref(false);
    const searchTerm = ref({ value: "" });
    const editData = ref({
      donVi: {},
    });
    const fullName = ref(null);
    const userName = ref(null);

    const fetchData = (filter) => {
      dataTableIsLoaded.value = true;

      donViFilter.value = filter.donViId;
      fullName.value = filter.fullName;
      userName.value = filter.userName;
      let condition = {
        donViId: filter ? filter.donViId : "",
        fullName: filter.fullName,
        userName: filter.userName,
        start: currentPage.value,
        limit: perPage.value,
        content: searchQuery.value,
        // sortBy: loadFilter.value,
      };
      console.log("condition", condition);
      getDataList(condition, (data) => {
        dataTableIsLoaded.value = false;
        // console.log(data);
        dataTable.value = data.data;
        totalRows.value = data.totalRows;
        // console.log("dataTable.value", response);
        dataMeta.value = {
          from:
            perPage.value * (currentPage.value - 1) +
            (dataTable.value.length ? 1 : 0),
          to: perPage.value * (currentPage.value - 1) + dataTable.value.length,
        };
        // searchTerm.value.value = "";
      });
    };

    //After add or update
    const reLoadDataTable = (data, id) => {
      // console.log("reLoadDataTable", data, id);
      if (data.id) {
        let index = dataTable.value.findIndex((el) => el.id == data.id);
        if (index != -1) {
          for (var name in dataTable.value[index]) {
            if (data[name]) {
              dataTable.value[index][name] = data[name];
            }
          }
          // console.log(data.donVi.id, donViFilter.value.id);
          if (data.donVi.id != donViFilter.value.id) {
            dataTable.value.splice(index, 1);
          }
        }
      } else {
        data.id = id;
        if (data.donVi.id == donViFilter.value.id) {
          dataTable.value.push(data);
        }
      }
    };

    const removeItem = (item) => {
      var index = dataTable.value.findIndex((el) => el.id == item.id);
      if (index != -1) {
        dataTable.value.splice(index, 1);
      }
    };

    const showLeftSlidebar = (data, id) => {
      isShowLeftSidebar.value = true;
      if (!data.donVi) {
        data.donVi = null;
      }
      editData.value = JSON.parse(JSON.stringify(data));
      // }
    };

    const pagination = (value) => {
      currentPage.value = value;
    };

    const perpage = (value) => {
      perPage.value = value;
    };
    const searchquery = (value) => {
      searchQuery.value = value;
    };
    watch([currentPage, perPage, searchQuery], () => {
      fetchData({
        donViId: donViFilter.value,
        fullName: fullName.value,
        userName: userName.value,
      });
    });

    return {
      pagination,
      perpage,
      searchquery,

      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,

      totalRows,
      dataMeta,

      donVis,
      donViFilter,
      getDonVi,
      fetchData,
      dataTable,
      dataTableIsLoaded,
      editData,
      searchTerm,

      isShowLeftSidebar,
      showLeftSlidebar,
      reLoadDataTable,
      removeItem,
    };
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
